import { useEffect, useState } from 'react';
import useScreenDimensions from 'components/common/modules/hooks/useScreenDimensions';
import { checkValue } from 'components/functions';

function useAkamaiVideo(videos, preferredEncoding = 'H.264') {
  const { width: screenWidth } = useScreenDimensions();
  const [video, setVideo] = useState(null);

  useEffect(() => {
    if (!checkValue(videos, true)) return;

    let bestMatchVideo = videos
      .filter((v) => v.encoding.value === preferredEncoding)
      .reduce((currentBest, currentVideo) => {
        const videoWidth = currentVideo.width.value;

        // Calculate the dimension difference
        const currentVideoDimensionDiff = Math.abs(screenWidth - videoWidth);
        const currentBestDimensionDiff = Math.abs(screenWidth - currentBest.width.value);

        // prioritize the closest dimension match
        return currentVideoDimensionDiff < currentBestDimensionDiff ? currentVideo : currentBest;
      });
    if (!bestMatchVideo) {
      bestMatchVideo = videos.reduce((currentBest, currentVideo) => {
        const videoWidth = currentVideo.width.value;

        // Calculate the dimension difference
        const currentVideoDimensionDiff = Math.abs(screenWidth - videoWidth);
        const currentBestDimensionDiff = Math.abs(screenWidth - currentBest.width.value);

        // Otherwise, prioritize the closest dimension match
        return currentVideoDimensionDiff < currentBestDimensionDiff ? currentVideo : currentBest;
      });
    }

    setVideo(bestMatchVideo);
  }, [videos, screenWidth, preferredEncoding]);

  return video;
}

export default useAkamaiVideo;
